import { ChangeDetectionStrategy, Component, input, ViewEncapsulation } from '@angular/core';
import { ArrowPosition } from '@shared/arrow/arrow.type';

@Component({
    selector: 'companyid-arrow[color][position]',
    imports: [],
    templateUrl: './arrow.component.html',
    styleUrl: './arrow.component.scss',
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ArrowComponent {
    public position = input.required<ArrowPosition>();
    public color = input.required<string>();
}
